import React from 'react';
import { Grid, FormControl, TextField, Table, TableBody, TableCell, TableRow } from '@mui/material';

const MissionData = (props) => {
    const { mission } = props;
    return (
           <Grid container item xs={12} spacing={2} >
                        <Grid item xs={12} sm={6} md={6}>
                            <FormControl fullWidth variant="outlined" size="small">
                            <TextField
                                fullWidth
                                size="small"
                                variant="standard"
                                name="title"
                                value={`Référence de la mission : ${mission ? mission.reference : ''}`}
                                disabled
                            />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <FormControl fullWidth variant="outlined" size="small">
                            <TextField
                                fullWidth
                                size="small"
                                variant="standard"
                                name="transportMeans"
                                value={mission ? `Moyen de transports souhaité : ${mission.transportMeans}` : ''}
                                disabled
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <FormControl fullWidth variant="outlined" size="small">
                            <TextField
                                fullWidth
                                size="small"
                                variant="standard"
                                disabled
                                value={mission ? `Objet de la mission : ${mission.mission_title}` : ''}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          {mission?.destinations?.length > 0 && (
                                       <Table sx={{color: '#8e9194ff', marginTop: '-8px'}} size="small">
                                        <TableRow>
                                          <TableCell sx={{ minWidth: '188px', fontWeight: 'bold' }}>Destination(s)</TableCell>
                                          <TableCell sx={{ minWidth: '180px', fontWeight: 'bold' }}>Date de début</TableCell>
                                          <TableCell sx={{ minWidth: '180px', fontWeight: 'bold' }}>Date de fin</TableCell>
                                          <TableCell sx={{ minWidth: '180px', fontWeight: 'bold' }}>Missionnaire(s)</TableCell>
                                        </TableRow>
                                        <TableBody sx={{color: '#8e9194ff'}}>
                                          {mission?.destinations?.map((destination, index) => (
                                            <TableRow key={index}>
                                              <TableCell sx={{color: '#8e9194ff'}}>{destination.lieu} / {destination.direction}</TableCell>
                                              <TableCell sx={{color: '#8e9194ff'}}>{`${new Date(destination.date_begin).toLocaleDateString()}`}</TableCell>
                                              <TableCell sx={{color: '#8e9194ff'}}>{`${new Date(destination.date_end).toLocaleDateString()}`}</TableCell>
                                              <TableCell sx={{color: '#8e9194ff'}}>{destination.missionnaries?.map(m => m.name)?.join(', ')}</TableCell>
                                            </TableRow>
                                          ))}
                                        </TableBody>
                                      </Table>
                                  )}
                          </Grid>
                        </Grid>
    )
}

export default MissionData;